import React from 'react';
import { Container, Dropdown } from 'react-bootstrap/';
import './Filters.scss';
import DropdownMenu from './dropdown/DropdownMenu'
import Geocoder from '../map/Geocoder';
import VenueType from './venue-type/VenueType';
import Button from '../button/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

const Filters = ({ filters, setFilters, map }) => {


    const handleFilterChange = (field, value) => {
        setFilters(prev => ({ ...prev, [field]: { ...prev[field], [value]: !prev[field][value] } }));
    };

    const CustomToggle = React.forwardRef(({ onClick }, ref) => (
        <Button
            buttonType="Secondary"
            buttonStyle="Standard" 
            buttonText="Filter Teams"
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
            // Add any other Button props here
        >
            <FontAwesomeIcon className='icon' icon={faCaretDown}></FontAwesomeIcon>
        </Button>
    ));

    return (
        <section className="filters container-fluid">


                <VenueType filters={filters} handleFilterChange={handleFilterChange}></VenueType>
                <Dropdown>
                    {/* <Dropdown.Toggle variant="dark" id="dropdown-basic">
                        Dropdown Button
                    </Dropdown.Toggle> */}
                    
                    <Dropdown.Toggle as={CustomToggle}>
                    </Dropdown.Toggle>
                    <DropdownMenu 
                        filters={filters} 
                        handleFilterChange={handleFilterChange} 
                        setFilters={setFilters}>  
                    </DropdownMenu>
                </Dropdown>
                <Geocoder map={map} />
        </section>
    );
}


export default Filters;
